<template>
    <div class="ui massive inverted vertical icon menu"
         style="margin: 0;z-index: 20000;position: absolute;top: 0; right: 0;height: 100%">
        <button
                class="ui icon button huge primary"
                style="border-radius: 0; width: 100%;background-color: #2185d0;height: 55px"
                @click="onToggleButtonClick">
            <font-awesome-icon
                    :icon="['fas',isOpen?'indent':'outdent']"
                    size="lg"/>
        </button>
        <template v-for="{id,icon,label} in menuItems">
            <menu-item
                    :icon="icon"
                    :title="label"
                    :isActive="selectedMenuItem===id"
                    @itemClick="onMenuItemClick(id)"
            />
        </template>
        <div style="width: 100%; position: absolute;bottom: 0">
            <slot>

            </slot>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    import MenuItem from './menu-item'

    import 'semantic-ui-css/components/menu.css'
    import 'semantic-ui-css/components/button.css'

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faOutdent, faIndent} from '@fortawesome/free-solid-svg-icons'

    library.add(faOutdent, faIndent);

    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

    export default {
        props: {
            defaultSelectedMenuItem: {
                type: Number,
                default: null
            },
            defaultIsOpen: {
                type: Boolean,
                default: false
            },
            menuItems: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                isOpen: this.defaultIsOpen,
                selectedMenuItem: this.defaultSelectedMenuItem
            }
        },
        computed: {},
        methods: {
            onToggleButtonClick: function () {
                this.isOpen = !this.isOpen;
            },
            onMenuItemClick: function (id) {
                this.selectedMenuItem = id;
                this.isOpen = true;
            },
            menuStateChanged: function () {
                this.$emit('menuStateChanged', this.isOpen, this.selectedMenuItem)
            }
        },

        watch: {
            isOpen: function () {
                this.menuStateChanged();
            },
            selectedMenuItem: function () {
                this.menuStateChanged();
            }
        },

        components: {
            MenuItem,
            FontAwesomeIcon
        }

    }
</script>

<style scoped>

</style>
